import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/solid'
import { UserSelectionContainer } from '../../components/contract/UserSelectionContainer'
import { clearJobPostTourDraftSession } from '../../utils/jobPostSessionStorage'

export const JobPostFirstPageView = ({ API_ENDPOINT, ...props }) => {
	const navigate = useNavigate()

	useEffect(() => {
		clearJobPostTourDraftSession()
	}, [])

	return (
		<div className="Job-Post-First-Page-Container">
			<div className="job-post-first-top-bar">
				<button
					type="button"
					className="job-post-first-back"
					onClick={() => navigate(-1)}
					aria-label="이전 화면으로">
					<ArrowLeftIcon className="job-post-first-back-icon" aria-hidden />
					뒤로
				</button>
			</div>
			<div className="title">공고 작성</div>
			<div className="progress-bar"></div>
			<UserSelectionContainer
				API_ENDPOINT={API_ENDPOINT}
				nextPath={'/posts/create/tour'}
				nextPath_no_checked_tour={'/posts/create/terms'}
			/>
		</div>
	)
}
